import { a, b, c } from './chunk-HDOT6H2Q.js';
import { b as b$1 } from './chunk-ZFTAEGDX.js';
import { a as a$1 } from './chunk-H7LXVQOY.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function u({action:e,title:l="Error",message:a$2}){return jsxs(a,{variant:"destructive",children:[jsx(a$1.Warning,{className:"h-4 w-4"}),jsx(b,{children:l}),jsx(c,{children:a$2}),e&&jsx(b$1,{className:"absolute end-4 top-4",size:"sm",variant:"outline",onClick:e.onClick,children:e.text})]})}

export { u as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-6UTREDOH.js.map